import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReissuePinMutationVariables = Types.Exact<{
  patientUuid: Types.Scalars['String'];
}>;


export type ReissuePinMutation = { readonly __typename?: 'Mutation', readonly createPin?: { readonly __typename?: 'CreatePinResult', readonly pin: string } | null };


export const ReissuePinDocument = gql`
    mutation reissuePin($patientUuid: String!) {
  createPin(patientUuid: $patientUuid) {
    pin
  }
}
    `;
export type ReissuePinMutationFn = Apollo.MutationFunction<ReissuePinMutation, ReissuePinMutationVariables>;

/**
 * __useReissuePinMutation__
 *
 * To run a mutation, you first call `useReissuePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissuePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissuePinMutation, { data, loading, error }] = useReissuePinMutation({
 *   variables: {
 *      patientUuid: // value for 'patientUuid'
 *   },
 * });
 */
export function useReissuePinMutation(baseOptions?: Apollo.MutationHookOptions<ReissuePinMutation, ReissuePinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReissuePinMutation, ReissuePinMutationVariables>(ReissuePinDocument, options);
      }
export type ReissuePinMutationHookResult = ReturnType<typeof useReissuePinMutation>;
export type ReissuePinMutationResult = Apollo.MutationResult<ReissuePinMutation>;
export type ReissuePinMutationOptions = Apollo.BaseMutationOptions<ReissuePinMutation, ReissuePinMutationVariables>;